//////////////////////////////////////////////
//! WebCamView 
//////////////////////////////////////////////

UpladWebCamView = function( dispatcher ) {

//--------------------------------------------
//! Static Vars
//--------------------------------------------
	this.BROWSED_T = "upload_photo";
	this.WEBCAM_T = "webcam_photo";
	this.SNAP_T = "take_photo";
	//WEBCAM STATIC VARS
	this.WEB_CAM_WIDTH = 1280;
	this.WEB_CAM_HEIGHT = 720;
	this.WEB_CAM_WIDTH_CROP = 1280;
	this.WEB_CAM_HEIGHT_CROP = 720;
	this.WEB_CAM_QUALITY = 100;

	this.MAX_IMAGE_WIDTH = 1024;
	this.FILE_SIZE_LIMIT = 10;
//--------------------------------------------
//! Vars
//--------------------------------------------

	this.webcamOn = false;
	this.dispatcher = dispatcher;
	this.shot = null;
	this.webCamActive = false;
	this.current_Image = null;

//--------------------------------------------/

	this.init();

};

UpladWebCamView.prototype = {

	constructor : UpladWebCamView,

	/*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function(){
		//image resizer
		this.hermite = new Hermite_class();
		
		if( (Detectizr.device.type === "desktop") && ( Detectizr.browser.name !== "safari") && (Detectizr.browser.name !== "ie") ){
			this.desktop = true;
			this.initWebCam();
		}
		else {
			this.hideWebcam();
		}
		
		this.bindEvents();
	},

	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/

	initWebCam : function(){

		Webcam.set({
			width : this.WEB_CAM_WIDTH,
			height : this.WEB_CAM_HEIGHT,
			crop_width : this.WEB_CAM_WIDTH_CROP,
			crop_height : this.WEB_CAM_HEIGHT_CROP,
			image_format : 'jpeg',
			jpeg_quality : this.WEB_CAM_QUALITY,
			enable_flash : false
		});

		Webcam.on( 'error', function( err ) {
			this.hideWebcam();
			$(dom.modal.shareErrorLinkId + " .alert__message").html( localisation.modal.errorWebcam )
			$(dom.modal.shareErrorLink).trigger("click");

		}.bindX( this ) );

	},

	bindEvents : function(){

		if( this.desktop ) this.bindEventsDesktop();
		$( dom.uploadPage.uploadMobBtn ).click( this.onBrowseBtn.bindX( this ) );
		$( dom.uploadPage.uploadBtn ).click( this.onBrowseBtn.bindX( this ) );
		$( dom.uploadPage.uploadInput ).change( this.onBrowseImageSel.bindX( this ) );

	},

	bindEventsDesktop : function(){

		//this.dispatcher.addEventListener( EVENTS.RESIZE, this.onStageResize.bindX (this ) );
		this.dispatcher.addEventListener( EVENTS.STOP_WEBCAM, this.dettach.bindX( this ) );
		this.dispatcher.addEventListener( EVENTS.WEBCAM_PHOTO, this.takePhoto.bindX( this ) );
		$(dom.uploadPage.webcamBtn).click( this.onWebCamBtn.bindX( this ) );
	
	},
	
	hideWebcam : function(){

		$( dom.uploadPage.webcamBtn).css( "display" , "none" );
		$( dom.uploadPage.webCamView ).removeClass( "is-shown" );
	},

	takePhoto : function(){

		Webcam.snap( function( data_uri ) {
			this.shot = data_uri;

			this.setCurrentImage( this.shot );
			this.imageSelected = this.shot;

			if( Detectizr.browser.name === "firefox"){
				this.resizeImage( true );
			}
			else{
				this.resizeImage( false );
			}

			this.dettach();
			this.dispatcher.dispatch( EVENTS.WEBCAM_CHANGE, "OFF" );
			//this.displaySnapShot();
			//app.pageController.onPageChangeNext();

		}.bindX(this) ) ;
	
	},
	
	displaySnapShot : function() {
	
		this.dettach();
		$( dom.uploadPage.snapView ).empty(); //empty it out//

		//create Image and append it call resize image to fix size
		var img = Utils.createImage( this.shot , this.onStageResize.bindX( this ) );
		//$( dom.uploadPage.snapView ).append( img );

	},

	displaySelectedPic : function() {

		if( this.desktop ) this.dettach();
		
		//reset input select
		$(dom.uploadPage.uploadInput).val( null );
		
		//hide all except picView
		this.hideItems( dom.uploadPage.picView );
		$(dom.uploadPage.uploadInput).val( null );
		
		//Empty container
		$( dom.uploadPage.picView ).empty();

		//CREATE IMAGE FROM BROWSED OR MOBILE PIC THEN CHECK EXIF DATA TO DRAW IT IN CANVAS WITH THE CORRECT ROTATION
		this.browsedImage = Utils.createImage( this.imageSelected , this.onImageReadyCheckExif.bind( this ) );

	},

	
	checkTextureLimit : function( b64 ,img){
		$( dom.uploadPage.picView + " img" ).css( "display" , "none" );

		//CHECK IF IMAGE IS TO BIG FOR WEBGL WE ARE SETTING A TEXTURE LIMIT 2048
		var naturalWidth = img.width;
		var naturalHeight = img.height;
		var ratio = naturalHeight / naturalWidth;
		
		//this.setCurrentImage( b64 );

		if( naturalWidth > this.MAX_IMAGE_WIDTH ){
			var resizedImage = Utils.resizeImage ( img, this.MAX_IMAGE_WIDTH, ratio );
			this.setCurrentImage( resizedImage );
			app.pageController.onPageChangeNext();
		}else{
			var resizedImage = Utils.resizeImage ( img, naturalWidth, ratio );
			this.setCurrentImage( resizedImage );
			app.pageController.onPageChangeNext();
		}

		$(dom.spinner.page).removeClass("is-shown");
	},

	resizeWebCam : function(){

		var newH =  200;
		
		if( newH > this.WEB_CAM_HEIGHT ) {
			newH = this.WEB_CAM_HEIGHT;
			newW = this.WEB_CAM_WIDTH;
		}

		var ratio = newH / this.WEB_CAM_HEIGHT;
		var newW = this.WEB_CAM_WIDTH * ratio;
		var vidPos = ( (-this.WEB_CAM_WIDTH / 2) + newW / 2 ) + "px";

		if( this.webcamOn === true ){
			
			$( dom.uploadPage.webCamView ).width( ( Utils.getPageWidth() ) );
			$( dom.uploadPage.webCamView ).height( ( Utils.getPageWidth() * .5625 ) );
			$( dom.uploadPage.webCamView +" video").width( ( Utils.getPageWidth() ) );
			$( dom.uploadPage.webCamView +" video").height( ( Utils.getPageWidth() * .5625 ) );
		
		}

	},

	resizeBrowsedImage : function(){

		var newH =  window.innerHeight * 0.5;
		var ratio = $( dom.uploadPage.picView + " img").width() / $( dom.uploadPage.picView + " img").height();
		$( dom.uploadPage.picView + " img").css( "height", newH + "px" );
		$( dom.uploadPage.picView + " img").css( "width", (newH * ratio ) + "px" );

	},

	hideItems : function( item ){

		$( dom.uploadPage.webCamView ).removeClass( "is-shown" );
		$( dom.uploadPage.snapView ).removeClass( "is-shown" );
		$( dom.uploadPage.picView ).removeClass( "is-shown" );
		if( item ){
			$( item ).addClass( "is-shown" );
		}

	},

	checkContinue : function(){

		if( $( dom.uploadPage.snapView ).hasClass( "is-shown" ) ) return true;
		if( $( dom.uploadPage.picView ).hasClass( "is-shown" ) ) return true;
		return false;

	},
	
	resetContinue : function(){

		$( dom.uploadPage.snapView ).removeClass( "is-shown" );
 		$( dom.uploadPage.picView ).removeClass( "is-shown" );
	
	},

	//SETS THE CURRENT BASE64 TO BE LOADED IN CANVAS FOR POSTERIOR EDITING
	
	setCurrentImage : function( src ){
		this.current_Image = src;
	},
	
	resizeImage : function( firefoxFix ){
		this.imageTag = Utils.createImage( this.imageSelected, function(){
			this.imageTag.onload = null;
			var size = this.getResizeImageValue( this.imageTag );
			if(firefoxFix){
				size.height =size.height*1.2;
			}
			var orientation = Utils.getExifOrientation( this.imageSelected )
			console.log(orientation)
			this.hermite.resize_image( this.imageTag , size.width , size.height ,null, true, orientation , function(){ 
				this.setCurrentImage( this.imageTag.src );
				$( dom.uploadPage.picView ).addClass( "is-shown" )
				app.pageController.onPageChangeNext();
				$(dom.spinner.page).removeClass("is-shown");

			}.bindX(this) );
		}.bindX(this)  );

	},


	getResizeImageValue : function(img){
		var width = img.width;
		var height = img.height;
		var ratio = height / width;

		if( width > this.MAX_IMAGE_WIDTH ){
			width = this.MAX_IMAGE_WIDTH;
			height = this.MAX_IMAGE_WIDTH * ratio
		}
		var obj ={};
		obj.width = width;
		obj.height = height;
		return obj
	},

	/*---------------------------------------------------
		EVENT HANDLERS 
	--------------------------------------------------*/

	attach : function( e ){ 
		this.webCamActive = true;
		Webcam.attach( dom.uploadPage.webCamView );
		this.dispatcher.dispatch( EVENTS.WEBCAM_CHANGE, "ON" );
	},

	dettach : function(){
		Webcam.reset();
		this.webcamOn = false;
		$( dom.uploadPage.webcamBtn + " span").html( localisation.pages.webcamBtn.startWebcam );
	},

	

	onWebCamBtn : function( e ){
	
		if( this.webcamOn === false ){
			this.dispatcher.dispatch( EVENTS.TRACKING_CLICK , this.WEBCAM_T );
			this.hideItems( dom.uploadPage.webCamView );
			this.webcamOn = true;
			$( dom.uploadPage.webcamBtn + " span").html( localisation.pages.webcamBtn.takePhoto );
			this.attach( e );
			this.onStageResize( e );
		} 
		else{
			this.dispatcher.dispatch( EVENTS.TRACKING_CLICK , this.SNAP_T );
			this.hideItems( dom.uploadPage.snapView );
			this.webcamOn = false;
			this.takePhoto();	
		} 

	},
	
	onStageResize : function( e ){

		if(this.webCamActive ) {
			this.resizeWebCam();
		}else{
			this.resizeBrowsedImage();
		}
	
	},

	onBrowseBtn : function( e ) {
		console.log("click")
		$(dom.uploadPage.uploadInput).click();
		e.preventDefault();

		this.dispatcher.dispatch( EVENTS.TRACKING_CLICK , this.BROWSED_T );
	},

	//loads browsed image
	onBrowseImageSel : function( event ){
		
		var selectedFile = event.target.files[0];
		
		//FORMAT CHECK
		if( !this.checkFormat( selectedFile ) ) return;

		//SIZE CHECK
		if( !this.checkSize( selectedFile ) ) return;
		
		var reader = new FileReader();
		$( dom.uploadPage.picView ).empty();

		reader.onload = function(frEvent) {

			this.imageSelected = frEvent.target.result;
			this.resizeImage();
			$(dom.uploadPage.uploadInput).val( null );
		
		}.bindX( this );
		
		reader.readAsDataURL( selectedFile );
	
	},
	
	checkFormat : function( selectedFile ){
		if( (selectedFile.type !== "image/jpeg") && (selectedFile.type !== "image/png") ){
			$(dom.modal.shareErrorLinkId + " .alert__message").html( localisation.modal.errorUpload );
			$(dom.modal.shareErrorLink).trigger("click");
			return false;
		}
		return true;
	},

	checkSize : function( selectedFile ){
		var size = ( selectedFile.size / 1048576 ).toFixed(4)
		//SIZE CHECK
		if( size > this.FILE_SIZE_LIMIT ){
			$(dom.modal.shareErrorLinkId + " .alert__message").html( localisation.modal.errorUploadSize );
			$(dom.modal.shareErrorLink).trigger("click");
			return false;
		}
		return true;
	},

	//DISPLAYS FIXED EXIF IMAGE
	
	onImageReadyCheckExif : function( img , src ){

		//FIX EXIF GET BACK AN IMAGE CORRECTLY ROTATED AND SCALE
		var b64 =  Utils.fixExifOrientation( img, src, img.width, img.height );
		
		//CREATE NEW IMAGE WITH NEW BASE 64 PROPERLY ROTATED
		var img2 = Utils.createImage( b64 , function(){
			this.checkTextureLimit( b64 ,img2 );
		}.bindX(this) );
		//$( dom.uploadPage.picView ).append( img2);

		// CHECKS TEXTURE LIMIT IT WILL RESIZE THE IMAGE JUST IN CASE.

	}


};
